export const WorkshopAppointmentTypes = Object.freeze({
    "MAINTENANCE": "maintenance",
    "FAILURE": "failure",
    "TYRES": "tyres",
    "ITV": "itv",
    "MAINTENANCE_PLUS_TYRES": "maintenance_plus_tyres",
    "FAILURE_PLUS_TYRES": "failure_plus_tyres",
    "VIP_SERVICE": "vip_service"
    })

export const WorkshopAppointmentFactoryTypes = [
    WorkshopAppointmentTypes.VIP_SERVICE
]